import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    graphAreaTitle: {
      textTransform: "none",
        color: "#373534",
        fontFamily: "Inter",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        marginBottom: "14px",
    },
    graphPaper: {
        position: "relative",
        borderRadius: "12px",
        padding: "24px 20px 24px 20px",
        backgroundColor: "#FCFDFD",
        border: "1px solid #F2F3F7",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
    },
    pieNoDataContainer: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        border: "1px solid " + theme.palette.grey.grey100,
        backgroundColor: theme.palette.grey.grey100
    },
    pieNoDataText: {
        color: "#9A9AAF",
        fontSize: "18px",
        fontFamily: "Inter",
    },
    subScoresSelection: {
      fontSize: "14px", 
      margin: "8px 0"
    }, 
}));

export default useStyles;